import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {ExportUtil} from '../../utils/exportUtil.js'
import {BaseComponent} from '../basecomponent.js';

/* global customElements */
class OptionYMQ extends BaseComponent {
	
	static get properties() {
		return {
			hideQuarter: {type: Boolean},
			hideMonth: {type: Boolean},
			calendarYears: {type: Boolean},
			required: {type: Boolean},
			name: {type: String}				
		};
	}
	
	constructor() {
		super();
		
		this.hideQuarter = false;
		this.hideMonth = false;
		this.calendarYears = false;
		this.name = '';
		this.required = false;
		
		var ymq = this;
		
		setTimeout(function(){
			ymq.normalizeBooleanFlags();
			ymq.init();
		});
	}

	/**
	 * ElementUtil sets attributes via setAttribute(key, value), so false becomes
	 * calendarYears="false". Lit Boolean properties treat any present attribute as true,
	 * which skipped month/quarter OR validation. Coerce string "false" back to false.
	 */
	normalizeBooleanFlags() {
		var ymq = this;
		['hideQuarter', 'hideMonth', 'calendarYears', 'required'].forEach(function(flagName) {
			var attributeValue = ymq.getAttribute(flagName);
			if (attributeValue === 'false' || attributeValue === '0') {
				ymq[flagName] = false;
				ymq.removeAttribute(flagName);
			} else if (attributeValue === 'true' || attributeValue === '') {
				ymq[flagName] = true;
			}
		});
	}
	
	render() {	
		return html`
			<slot></slot>
		`;
	}
	
	init() {
		var ymq = this;
			
		var yearModel = {};	
			
		ymq.year = ElementUtil.create({
			tag: 'vaadin-combo-box',						
			'item-value-path': 'code',
			'item-label-path': 'description',
			style: 'width: 25%; margin-right: 10px;',			
			label: 'Year' + (ymq.required ? ' *' : ''),
			name: ymq.name + '-year',
			postinit: function (combo) {				
			},
			listeners: {
				change: function() {
					var newYear = ymq.year.value;
					if (newYear == null || newYear === '') {
						return;
					}
					
					//set months
					ymq.month.value = null;
					ymq.month.items = yearModel[newYear].months;
					
					//set quarters
					ymq.quarter.value = null;
					ymq.quarter.items = yearModel[newYear].quarters;
				}
			}
		});
		
		ymq.month = ElementUtil.create({
			tag: 'vaadin-combo-box',						
			'item-value-path': 'code',
			'item-label-path': 'description',
			style: 'flex: 1; margin-right: 10px;',
			'class': (ymq.hideMonth ? 'hide' : ''),
			label: 'Month' + (ymq.required && (ymq.calendarYears || ymq.hideQuarter) ? ' *' : ''),
			name: ymq.name + '-month',
			postinit: function (combo) {				
			},
			listeners: {
				change: function() {
					if (ymq.month.value) {
						ymq.quarter.disabled = true;
					} else {
						ymq.quarter.disabled = false;
					}
					ymq.clearMonthQuarterInvalid();
				}
			}
		});
		
		ymq.quarter = ElementUtil.create({
			tag: 'vaadin-combo-box',						
			'item-value-path': 'code',
			'item-label-path': 'description',
			style: 'flex: 2;',
			'class': (ymq.hideQuarter ? 'hide' : ''),
			label: 'Quarter' + (ymq.required && (ymq.calendarYears || ymq.hideMonth) ? ' *' : ''),
			name: ymq.name + '-quarter',
			postinit: function (combo) {				
			},
			listeners: {
				change: function() {
					if (ymq.quarter.value) {
						ymq.month.disabled = true;
					} else {
						ymq.month.disabled = false;
					}
					ymq.clearMonthQuarterInvalid();
				}
			}
		});
		
		var container = ElementUtil.create({
			tag: 'div',
			style: 'width: 100%;',
			children: [
				ymq.year,
				ymq.month,
				ymq.quarter
			]
		});
		
		ymq.append(container);
		
		//load data
		Service.getReportService().getYearMonthQuarter(ymq.calendarYears).then(function(data){
			
			var years = [];
			data.forEach(function(item){
				var yearCode = '' + item.year;
				years.push({
					code: yearCode,
					description: yearCode
				});
				yearModel[yearCode] = {
					year: yearCode,
					months: item.months,
					quarters: item.quarters
				};
			});			
			ymq.year.items = years;
			ymq.year.value = '' + (new Date()).getFullYear();
			
			
			if (ymq.required) {
				ymq.year.required = true;
				// IFTA tax-rate periods require month OR quarter (not both).
				// Calendar periods may be year-only, so do not force month/quarter.
				if (!ymq.calendarYears && !ymq.hideMonth && !ymq.hideQuarter) {
					ymq.month.label = 'Month *';
					ymq.quarter.label = 'Quarter *';
				} else if (!ymq.calendarYears && ymq.hideMonth) {
					ymq.quarter.required = true;
				} else if (!ymq.calendarYears && ymq.hideQuarter) {
					ymq.month.required = true;
				}
			}
		
			var event = new Event("change");
			ymq.year.dispatchEvent(event);			
			
			var readyEvent = new CustomEvent('ready', { detail: '' });
			ymq.dispatchEvent(readyEvent);		
		});
		
	}
	
	setCustomValue(value) {
		var ymq = this;
		//2023,3(0-11),1(1-4)
		
		if (value) {
			var parts = value.split(',');
			ymq.year.value = parts[0] ? '' + parts[0] : null;
			
			var event = new Event("change");
			ymq.year.dispatchEvent(event);
			
			ymq.month.value = parts[1] != null && parts[1] !== '' ? '' + parts[1] : null;			
			ymq.quarter.value = parts[2] != null && parts[2] !== '' ? '' + parts[2] : null;			
		}
	}
	
	getSelectedCode(combo) {
		if (!combo) {
			return null;
		}
		if (combo.value != null && combo.value !== '') {
			return '' + combo.value;
		}
		if (combo.selectedItem && combo.selectedItem.code != null && combo.selectedItem.code !== '') {
			return '' + combo.selectedItem.code;
		}
		return null;
	}

	clearMonthQuarterInvalid() {
		var ymq = this;
		if (ymq.month) {
			ymq.month.invalid = false;
			ymq.month.errorMessage = '';
		}
		if (ymq.quarter) {
			ymq.quarter.invalid = false;
			ymq.quarter.errorMessage = '';
		}
	}

	/**
	 * Used by dl-form-panel.isValid(). For IFTA tax-rate periods, year is required
	 * and either month or quarter must be selected (not both required).
	 */
	validate() {
		var ymq = this;
		ymq.normalizeBooleanFlags();
		var valid = true;

		if (ymq.year && typeof ymq.year.validate === 'function') {
			if (!ymq.year.validate()) {
				valid = false;
			}
		}

		if (ymq.required && !ymq.calendarYears && !ymq.hideMonth && !ymq.hideQuarter) {
			var hasMonth = ymq.getSelectedCode(ymq.month) != null;
			var hasQuarter = ymq.getSelectedCode(ymq.quarter) != null;
			if (!hasMonth && !hasQuarter) {
				valid = false;
				var periodMessage = 'Select a month or a quarter';
				if (ymq.month) {
					ymq.month.invalid = true;
					ymq.month.errorMessage = periodMessage;
				}
				if (ymq.quarter) {
					ymq.quarter.invalid = true;
					ymq.quarter.errorMessage = periodMessage;
				}
			} else {
				ymq.clearMonthQuarterInvalid();
			}
		} else if (ymq.required && !ymq.calendarYears && ymq.hideMonth && ymq.quarter
			&& typeof ymq.quarter.validate === 'function') {
			if (!ymq.quarter.validate()) {
				valid = false;
			}
		} else if (ymq.required && !ymq.calendarYears && ymq.hideQuarter && ymq.month
			&& typeof ymq.month.validate === 'function') {
			if (!ymq.month.validate()) {
				valid = false;
			}
		}

		return valid;
	}
	
	getCustomValue() {
		var ymq = this;
		
		return {
			year: ymq.getSelectedCode(ymq.year),
			month: ymq.getSelectedCode(ymq.month),
			quarter: ymq.getSelectedCode(ymq.quarter)
		};
	}
	
};
customElements.define('dl-option-yearmonthquarter', OptionYMQ);